The preference for remuneration (including salary or hourly rate, benefits) for a position.
